import React, { useState } from 'react'
import LIGHT_ICON from '@public/assets/icon_lightbuld.svg'
import { SelectContactTooltipTemplate } from '@/components/common/SelectContactTooltipTemplate'

function SelectContactTooltipLight() {
  const [showNarrativeTip, setShowNarrativeTip] = useState(false)

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setShowNarrativeTip(true)}
      onMouseLeave={() => setShowNarrativeTip(false)}
      onClick={event => event.stopPropagation()}
      onMouseDown={event => event.stopPropagation()}
    >
      <span className="inline-flex cursor-pointer items-center gap-1 px-0.5 text-xs font-normal leading-5 tracking-[0.5px] text-[#ADADAD]">
        <span>Tip</span>
        <img src={LIGHT_ICON} className="size-3.5" />
      </span>
      {showNarrativeTip ? (
        <span className="absolute bottom-7 left-0 z-[1000003] w-[216px] rounded bg-[#292929] px-2 py-1 text-white">
          <SelectContactTooltipTemplate />
        </span>
      ) : null}
    </span>
  )
}

export default SelectContactTooltipLight
